import React from 'react';
import Navbar from './Nav';
import Footer from './Footer';
import Sidebar from './Sidebar';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact,faJs ,faCss3Alt} from '@fortawesome/free-brands-svg-icons'; 
import Carousel from './Carousel';

import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import Skills from './Skills';
import PresenceSlider from './demo';
import WhatIBuild from './WhatIBuild';
import FeaturedProject from './FeaturedProject';


const Home = () => {
  var ReactRotatingText = require("react-rotating-text");
 
    return (
      <div className="overflow-x-hidden text-white elegant  background">
        <Navbar />
        <div  className="w-full container px-5 block md:flex py-24 mx-auto gap-5  justify-between">
          <div className="w-full md:w-1/2 lg:w-1/3  mx-auto">
            <Sidebar />
          </div>
          <div
            className="w-full md:w-1/2 lg:w-2/3 mx-auto"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <div className="bg-gradient-to-r from-gray-500 to-lime-800 rounded-xl  container px-5 py-10 my-5">
              <div className="text-lg">
                <span className="text-sm ">Hello!</span>
                <br />
                <br />
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-lime-50 via-lime-600 to-lime-300 text-4xl md:text-3xl lg:text-5xl   font-bold ">
                  <ReactRotatingText
                    className=""
                    items={[
                      "Im Tayyab",
                      "Mern Stack Developer",
                      "React.js Developer",
                    ]}
                  />
                </span>
                <br />
                <br />
                I’m Tayyab, a full-stack developer specializing in the MERN
                stack, currently studying at the Institute of Science and
                Technology in Dhaka. With experience in digital consulting, I
                craft functional and visually striking solutions that blend
                technical excellence with minimalist and brutalist design
                principles
              </div>
            </div>
            <div className=" lg:flex rounded-xl  px-3 justify-center mx-auto py-5">
              <div
                className="lg:w-1/2 w-full bg-gradient-to-r from-gray-500 to-lime-800 py-5 rounded-xl lg:mr-3 container mx-auto"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <p className="text-sm px-3 text-zinc-300">
                  I'm Muhammad Tayyab A, a MERN stack developer and student. I
                  have Mern Stack experience, gained through coursework and
                  freelancing on Fiverr and Upwork. I'm proficient in React,
                  Node, Express, MongoDB, C, and C++ for problem solving and
                  passionate about building impactful web applications. <br />
                  <br />
                  <Link
                    to={"/about"}
                    className="text-lg text-gray-50 font-extrabold hover:underline "
                  >
                    Learn More About Me
                  </Link>
                </p>
              </div>
              <div
                className="py-5 rounded-xl lg:ml-2 my-2 mx-auto container lg:w-1/2 w-full bg-gradient-to-r from-gray-500 to-lime-800 px-4"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <p className="my-4 text-2xl font-bold text-lime-500 Riesling">
                  OFFERED SERVICES
                </p>
                <div
                  className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-bold rounded-full shadow-xl"
                  class=" flex justify-center mx-auto gap-6 mt-6 "
                >
                  <Link
                    to={"/services"}
                    href="#"
                    class="socialContainer containerOne rounded-2xl"
                  >
                    <FontAwesomeIcon
                      icon={faReact}
                      className="w-12 h-12 mx-2 my-2 "
                    />
                  </Link>

                  <Link
                    to={"/services"}
                    href="#"
                    class="socialContainer containerTwo rounded-2xl "
                  >
                    <FontAwesomeIcon
                      icon={faJs}
                      className="w-12 h-12 mx-2 my-2"
                    />{" "}
                  </Link>

                  <Link
                    to={"/services"}
                    href="#"
                    class="socialContainer containerThree rounded-2xl "
                  >
                    <FontAwesomeIcon
                      icon={faCss3Alt}
                      className="w-12 h-12 mx-2 my-2"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <WhatIBuild/>
        <Skills/>
       {/*  <div
          className="block md:flex container px-8  py-12 mx-auto  justify-center"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="w-full md:w-1/2 md:text-7xl text-4xl text-center md:mt-20  Riesling  text-lime-500">
            {" "}
            Works
          </div>
          <div className="w-full md:w-1/2 text-center md:text-right">
            Here are some of the best projects I’ve had the pleasure of working
            on. <br />
            <br />
            First up is an e-commerce website that combines sleek design with
            user-friendly navigation, making shopping a breeze. Next, there’s a
            photo editing tool that allows users to easily enhance their images
            with fun filters and effects. I also developed an interactive quiz
            platform where users can test their knowledge and compete with
            friends. Additionally, I created a word counter that helps users
            keep track of their writing effortlessly. Finally, there's a
            video-sharing site that mimics popular platforms, offering users a
            space to upload, share, and enjoy videos.
            <br />
            <br />
            Each project showcases my commitment to quality and creativity in
            web development!
          </div>
        </div> */}
    <FeaturedProject/>
        <PresenceSlider/>
        <Footer />
      </div>
    );
};

export default Home;